import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import {
  clearAuthExpiredGuard,
  getLoginPath,
  getStoredAuthToken,
  handleExpiredAuthSession,
  isAuthTokenValid,
} from "../utils/authSession";

const RequireAuth = ({ children }) => {
  const token = getStoredAuthToken();
  const hasToken = Boolean(token);
  const tokenValid = hasToken && isAuthTokenValid(token);

  useEffect(() => {
    if (hasToken && !tokenValid) {
      handleExpiredAuthSession();
      return;
    }

    if (tokenValid) {
      clearAuthExpiredGuard();
    }
  }, [hasToken, tokenValid]);

  if (!hasToken) {
    return <Navigate to={getLoginPath()} replace />;
  }

  if (!tokenValid) {
    return null;
  }

  return children;
};

export default RequireAuth;
